var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCaretDown = function SvgIconCaretDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#343330",
    d: "M19.924 7.33a1.125 1.125 0 0 0-1.594 0l-6.702 6.703-6.704-6.702A1.127 1.127 0 1 0 3.33 8.925l7.5 7.5a1.125 1.125 0 0 0 1.594 0l7.5-7.5a1.125 1.125 0 0 0 0-1.594"
  })));
};
export default SvgIconCaretDown;